import { Dialog, DialogContent } from "@/components/ui";
import { SignUpContent } from "../signup-content";
import { useAuthState } from "@/store/auth";
import { DialogCloseIcon } from "@/components/shared/dialog-close";

export function SignUpModal() {
  const {
    data: { signUpModalOpen },
    showModal,
  } = useAuthState();
  const onClose = () => {
    showModal();
  };
  return (
    <Dialog open={signUpModalOpen}>
      <DialogContent className="w-[343px]">
        <DialogCloseIcon onClose={onClose} />
        <SignUpContent />
      </DialogContent>
    </Dialog>
  );
}
